import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import WhatsAppButton from '../components/WhatsAppButton';

import Mision from '../components/Mision';
import Compromiso from '../components/Compromiso';
//import Equipo from '../components/Equipo';
import Instalaciones from '../components/Instalaciones';

import Indicadores from '../components/Indicadores';
import ClientesSlider from '../components/ClientesSlider';

import PorqueElegirnos from '../components/PorqueElegirnos';

import Footer from '../components/Footer';

function Home() {
  return (
    <>
      <Navbar />
      <HeroSlider />

      {/* 🔥 SECCIONES */}
      <Indicadores />   {/* 👈 AQUÍ va, justo después del banner */}

      <PorqueElegirnos />
      <Compromiso />
       {/*<Equipo />*/}
       {/* 🔥 NUEVO SLIDER */}
      <ClientesSlider />
      <Instalaciones />

   

      <Footer />

      <WhatsAppButton />
    </>
  );
}

export default Home;